AutoInsertionView = require 'app/scripts/views/internal/autocomplete/auto-insertion-view'
CompleterUtil = require 'app/scripts/views/internal/autocomplete/completer-util'
CheckItemMenuView = require 'app/scripts/views/checklist/check-item-menu-view'
Dates = require 'app/scripts/lib/dates'
DueDateHelpers = require 'app/scripts/views/internal/due-date-helpers'
EditableView = require 'app/scripts/views/internal/editable-view'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ forNamespace } = require 'app/common/lib/util/i18n'
moment = require 'moment'
{ OrganizationFeature } = require '@trello/product-features'
PopOver = require 'app/scripts/views/lib/pop-over'
TFM = require 'app/scripts/lib/markdown/tfm'
Util = require 'app/scripts/lib/util'
friendlyLinks = require 'app/scripts/views/internal/friendly-links'
{ mixin } = require 'app/scripts/lib/mixin_DO_NOT_USE'
{ track } = require '@trello/analytics'
t = require('app/scripts/views/internal/teacup-with-helpers')('checklist_item')
{ toggleAssignPopover } = require 'app/scripts/views/checklist/toggle-assign-popover'
{ toggleDatePopover } = require 'app/scripts/views/checklist/toggle-date-popover'
memberAvatarTemplate = require 'app/scripts/views/templates/member_avatar'
{ avatarDomain } = require '@trello/config'

viewTitle = forNamespace('view title')

template = t.renderable ({ canAssign, canSetDueDate, editable }) ->
  t.div '.checklist-item-checkbox', { class: t.classify({ enabled: editable, 'js-toggle-checklist-item': editable }) }, ->
    t.icon 'check', { class: 'checklist-item-checkbox-check' }

  t.div '.checklist-item-details.non-empty.js-checkitem', { class: t.classify({ editable }), attr: 'name' }, ->
    t.div '.checklist-item-row.js-checkitem-row.current', ->
      t.span '.checklist-item-assignee.js-checklist-item-assignee.hide-on-edit'
      t.span '.checklist-item-text-and-due.hide-on-edit', ->
        t.span '.checklist-item-details-text.markeddown.js-checkitem-name'
        t.span '.checklist-item-due.js-checklist-item-due'
      if editable
        t.div '.edit.options-menu', { class: t.classify({ assign: canAssign, due: canSetDueDate }) }, ->
          t.textarea '.field.full.single-line.js-checkitem-input', { type: 'text' }

    if editable
      t.p '.edits-warning.quiet', ->
        t.format 'you-have-unsaved-edits-on-this-field'
        t.text ' '
        t.a '.js-view-edits', { href: '#' }, ->
          t.format 'view-edits'
        t.text " - "
        t.a '.js-discard-edits', { href: '#' }, ->
          t.format 'discard'

    if editable
      t.div '.checklist-item-menu-wrapper.hide-on-edit', ->
        t.div '.checklist-item-menu.js-open-menu', ->
          t.span '.icon-sm.icon-overflow-menu-horizontal'

assigneeTemplate = t.renderable ({ member }) ->
  if member
    t.button '.subtle', ->
      t.div '.member.m-member-mod-24', ->
        memberAvatarTemplate(member)

dueTemplate = t.renderable (due, className) ->
  if due
    t.button '.subtle', { class: className }, ->
      t.icon 'clock'
      if due
        t.text due

module.exports = mixin AutoInsertionView, CompleterUtil, class CheckItemView extends EditableView
  className: 'checklist-item'

  allowNewlines: false

  initialize: ->
    @listenTo @model,
      'change:name': ->
        @renderName()
        @renderAssignee()
        @renderDue()
      'change:state': ->
        @renderState()
        @renderDue()
    super

  events:
    'keyup .js-checkitem-input': 'keyAutoMention'
    'click .js-toggle-checklist-item': 'toggleState'

    'click .js-open-menu': 'openMenu'

    'click .js-open-mention-selector': 'commentMentionMember'
    'click .js-open-emoji-selector': 'commentAddEmoji'
    'movecheckitem': 'moveCheckItem'

    # Advanced Checklists
    'click .js-open-assign-selector': toggleAssignPopover({
      getInput: -> @el.querySelector('.js-checkitem-input')
      title: viewTitle('assign')
      getCardMembers: -> @model.getCard().memberList.toJSON()
      getBoardMembers: -> @model.getBoard().memberList.filterDeactivated(force: true).toJSON()
    })

    'click .js-open-due-selector': toggleDatePopover({
      getInput: -> @el.querySelector('.js-checkitem-input')
      title: viewTitle('change due date')
    })

  getCard: -> @model.getCard()

  render: ->
    view = @
    model = @model

    editable = @model.editable()
    hasAdvancedChecklists = @_hasAdvancedChecklists()

    @$el.html(
      template({
        canAssign: editable && hasAdvancedChecklists
        canSetDueDate: editable && hasAdvancedChecklists
        editable: editable
      })
    )

    @renderAssignee()
    @renderDue()
    @renderName()
    @renderState()
    @recallDrafts()

    @

  getTextInput: ->
    @$('.js-checkitem-input')

  getMentionTarget: ->
    @$('.js-open-mention-selector')[0]

  getEmojiTarget: ->
    @$('.js-open-emoji-selector')[0]

  renderName: (e) ->
    name = @model.get('name')

    @$('.js-checkitem-row').data('unmarkeddown', name)

    nameHtml = TFM.checkItems.format(name, { textData: @model.get('nameData') }).output
    $name = @$('.js-checkitem-name')
    $name.empty().append(nameHtml)

    friendlyLinks $name[0], @model.getBoard()
    return

  _hasAdvancedChecklists: ->
    featureFlagClient.get('remarkable.advanced-checklists', false) &&
    @model.getBoard()?.getOrganization()?.isFeatureEnabled(OrganizationFeature.AdvancedChecklists)

  renderAssignee: ->
    if !@_hasAdvancedChecklists()
      return

    board = @model.getBoard()
    initialMention = @model.get('name').match(/^@([a-z0-9_]{3,})\b/)?[1]

    member = initialMention && board.memberList.find (member) ->
      member.get('username') == initialMention

    @$('.js-checklist-item-assignee').html(assigneeTemplate({
      member: member?.toJSON()
    }))
    .toggleClass('no-assignee', !member?)
    return

  renderDue: ->
    if !@_hasAdvancedChecklists()
      return

    potentialDueDate = @model.get('name').match(/\b\d\d\d\d-\d\d-\d\d$/)?[0]
    momentDate = potentialDueDate && moment(potentialDueDate)
    due = if momentDate?.isValid() then momentDate.toDate() else undefined

    dueText = due && Dates.toDateString(due)

    className =
      if due
        complete = @model.get('state') == 'complete'
        DueDateHelpers.classForDueDate(momentDate.add(1, 'days').toDate(), complete)
      else
        ""

    @$('.js-checklist-item-due').html(dueTemplate(dueText, className))
    .toggleClass('no-due', !due)

    return

  renderState: (e) ->
    data = @model.toJSON()
    data.checked = (data.state == 'complete')
    @$el.toggleClass('checklist-item-state-complete', data.checked)
    return

  toggleState: (e) ->
    return if !@model.editable()

    isComplete = @model.get('state') == 'complete'

    newState = if isComplete then 'incomplete' else 'complete'

    if newState == 'complete'
      @$el.addClass('checklist-item-fade-out')

      @setTimeout =>
        @model.update('state', newState)
        @$el.removeClass('checklist-item-fade-out')
      , 200

    else
      @$el.removeClass('checklist-item-fade-out')
      @model.update('state', newState)

    track("Checklist", "Toggle Checklist Item State", newState)

    return

  moveCheckItem: (e, ui, checklist, toDifferentChecklist) ->
    if !toDifferentChecklist && @model.getChecklist() != checklist
      # We've already handled this as a move to a different checklist
      return

    checkItems = ui.item.parent().children()
    index = checkItems.index(ui.item)
    pos = checklist.calcPos(index, @model)

    if toDifferentChecklist
      @model.update { pos, idChecklist: checklist.id }
      @model.collection.remove(@model)
      checklist.checkItemList.add(@model)
    else
      @model.update('pos', pos)

    checklist.checkItemList.sort({ silent: true })

    track("Checklist", "Reorder Checklist Item")

  commitEdits: (e) ->
    PopOver.hide()
    if @$('.js-checkitem-input').val().length == 0
      @model.destroy()
    else
      super

  openMenu: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: e.target
      view: CheckItemMenuView
      options: { @model, @modelCache }
      keepEdits: true

